<div
  class="sidebar-area bg-white active"
  [ngClass]="{'active': isSidebarToggled}"
  [class.component-dark-theme]="themeService.isDark()"
  [class.dark-sidebar]="true"
  [class.right-sidebar]="themeService.isRightSidebar()"
  [class.hide-sidebar]="themeService.isHideSidebar()"
  [class.card-borderd-theme]="true"
  [class.rtl-enabled]="themeService.isRTLEnabled()"
  >
  <div class="logo bg-white">
    <a href="javascript:void(0)" class="d-flex align-items-center" (click)="$event.preventDefault()">
      <span class="fw-semibold">{{  user?.isSystemAdministrator() ? 'Admin' : user?.isAssociationResponsiblePerson()  ? 'Udruga' : 'Općina' }}</span>
    </a>
  </div>
  <div
    (click)="toggle()"
    class="burger-menu"
    [ngClass]="{'active': isSidebarToggled}"
    >
    <span class="top-bar"></span>
    <span class="middle-bar"></span>
    <span class="bottom-bar"></span>
  </div>
  <ng-scrollbar visibility="hover">
    <div class="sidebar-inner">
      <div class="sidebar-menu">
        <mat-accordion>

          @if (user?.isMunicipalityAdministrator()) {
            <a routerLink="/municipality/associations" class="sidebar-menu-link" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
              <i class="material-symbols-outlined">
                groups
              </i>
              <span class="title">Udruge</span>
            </a>
          }
          @if (user?.isMunicipalityAdministrator()) {
            <a routerLink="/municipality/grants" class="sidebar-menu-link" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
              <i class="material-symbols-outlined">
                campaign
              </i>
              <span class="title">Natječaji</span>
            </a>
          }
          @if (user?.isMunicipalityAdministrator()) {
            <a routerLink="/municipality/applications" class="sidebar-menu-link" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
              <i class="material-symbols-outlined">
                fact_check
              </i>
              <span class="title">Prijave</span>
            </a>
          }
          @if (user?.isMunicipalityAdministrator()) {
            <a routerLink="/municipality/allocations" class="sidebar-menu-link" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
              <i class="material-symbols-outlined">
                monetization_on
              </i>
              <span class="title">Dodjele</span>
            </a>
          }
          @if (user?.isMunicipalityAdministrator()) {
            <a routerLink="/municipality/projects" class="sidebar-menu-link" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
              <i class="material-symbols-outlined">
                work_outline
              </i>
              <span class="title">Projekti</span>
            </a>
          }
          @if (user?.isMunicipalityAdministrator()) {
            <a routerLink="/municipality/notifications" class="sidebar-menu-link" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
              <i class="material-symbols-outlined">
                notifications
              </i>
              <span class="title">Obavijesti</span>
            </a>
          }


          @if (user?.isAssociationResponsiblePerson()) {
            <a routerLink="/association/allocations" class="sidebar-menu-link" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
              <i class="material-symbols-outlined">
                monetization_on
              </i>
              <span class="title">Izravne dodjele</span>
            </a>
          }

          @if (user?.isAssociationResponsiblePerson()) {
            <a routerLink="/association/grants" class="sidebar-menu-link" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
              <i class="material-symbols-outlined">
                campaign
              </i>
              <span class="title">Natječaji</span>
            </a>
          }
          @if (user?.isAssociationResponsiblePerson()) {
            <a routerLink="/association/applications" class="sidebar-menu-link" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
              <i class="material-symbols-outlined">
                fact_check
              </i>
              <span class="title">Prijave</span>
            </a>
          }
          @if (user?.isAssociationResponsiblePerson()) {
            <a routerLink="/association/projects" class="sidebar-menu-link" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
              <i class="material-symbols-outlined">
                work_outline
              </i>
              <span class="title">Projekti</span>
            </a>
          }
          @if (user?.isAssociationResponsiblePerson()) {
            <a routerLink="/association/notifications" class="sidebar-menu-link" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
              <i class="material-symbols-outlined">
                notifications
              </i>
              <span class="title">Obavijesti</span>
            </a>
          }


          @if (user?.isSystemAdministrator()) {
            <a routerLink="/administrator/municipalities" class="sidebar-menu-link" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
              <i class="material-symbols-outlined">
                dashboard
              </i>
              <span class="title">Općine</span>
            </a>
          }
          @if (user?.isSystemAdministrator()) {
            <a routerLink="/administrator/users" class="sidebar-menu-link" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
              <i class="material-symbols-outlined">
                groups
              </i>
              <span class="title">Korisnici</span>
            </a>
          }

          <a routerLink="/authentication/logout" class="sidebar-menu-link" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
            <i class="material-symbols-outlined">
              logout
            </i>
            <span class="title">Odjava</span>
          </a>
        </mat-accordion>
      </div>
    </div>
  </ng-scrollbar>
</div>
